<script setup>
import { ref, computed, reactive, onMounted } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import SertHeader from '@/components/blocks/SertHeader.vue';
import BaseInput from '@/components/ui/BaseInput.vue';
import BaseMessage from '@/components/ui/BaseMessage.vue';
import BaseBtnLookSert from '../ui/BaseBtnLookSert.vue';

const storeSert = useSertStore();

const nextSreen = async () => {   
    storeSert.goToScreen(storeSert.screens.sum)
    history.pushState(null, "", `#${storeSert.screens.sum}`)       
};

const previousSreen = () => {
    storeSert.goToScreen(storeSert.screens.design)
    history.pushState(null, "", `#${storeSert.screens.design}`)
}
onMounted(() => {
    // window.scrollTo({
    //     top: 0,
    //     behavior: "smooth" 
    // });
})
</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="5">
                <template #title>Информация о получателе</template>
                <template #text>Введите имя человека, которому предназначен сертификат и напишите теплые слова, которые сделают подарок еще более особенным.</template>
            </SertHeader>       
            <div class="form">
                <div class="form__row">
                    <BaseInput 
                        type="text" 
                        state-key="userName"
                    >
                        Имя получателя в дательном падеже
                    </BaseInput>
                </div>
                <div class="form__row">
                    <BaseMessage />
                </div>
            </div>
        </div>
        <div class="constructor__btns-inner">
            <div class="constructor__btns">
                <button class="btn --black" @click="previousSreen">
                    <span>Назад</span>
                </button>
                <button :disabled="storeSert.isBtnDisabled(['message'])" class="btn --full" @click="nextSreen">
                    <span>Далее</span>
                </button>
                <BaseBtnLookSert/>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>